import { GET_ALL_SUBSCRIBE, TOGGLE_SUBSCRIBE, POST_SUBSCRIBE, RESET_SUBSCRIBE } from "../actions/types";

const initialState = {
  all_subscribe: {},
  subscribe_loading: false,
  subscribe_success: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_SUBSCRIBE:
      return {
        ...state,
        all_subscribe: action.payload,
      };
    case POST_SUBSCRIBE:
      return {
        ...state,
        subscribe_success: true,
      };
    case TOGGLE_SUBSCRIBE:
      return {
        ...state,
        subscribe_loading: !state.subscribe_loading,
      };
    case RESET_SUBSCRIBE:
      return {
        ...state,
        subscribe_success: false,
      };
    default:
      return state;
  }
}
